// extracted by mini-css-extract-plugin
module.exports = {"jcIcon":"jcIcon","iconLoading":"iconLoading"};